// ── Your publications ──────────────────────────────────────────────────────
// Add a new object to the top of the array for each paper. `me` is highlighted
// in the author list. Any link left out is simply not shown.

export const ME = 'Fabian Morelli';

export const publications = [
  {
    id: 'partial-fusion',
    title: 'Partial Fusion of Neural Networks: Efficient Tradeoffs Between Ensembles and Weight Aggregation',
    authors: ['Fabian Morelli', 'Stephan Eckstein'],
    venue: 'ICML 2026',
    year: 2026,
    abstract:
      'A method that sits between ensembling and weight averaging. It merges ' +
      'only the most similar neurons across networks, matched with optimal ' +
      'transport, so you can trade compute against accuracy by choosing how ' +
      'much of the network to fuse.',
    links: {
      arxiv: 'https://arxiv.org/abs/2605.22350',
      code: 'https://github.com/Fabian-Mor/partial_fusion_nn',
    },
    selected: true,
  },
  {
    id: 'sae-ft',
    title: 'Sparse Autoencoders enable Robust and Interpretable Fine-tuning of CLIP models',
    authors: ['Fabian Morelli', 'Arnas Uselis', 'Ankit Sonthalia', 'Seong Joon Oh'],
    venue: 'arXiv preprint',
    year: 2026,
    abstract:
      'A way to fine-tune CLIP without losing its robustness. A sparse ' +
      'autoencoder identifies meaningful features in the visual representation, ' +
      'and fine-tuning is penalized for adding or removing them. This reduces ' +
      'catastrophic forgetting and shows which features change during ' +
      'adaptation. It is cheap to run and holds up on distribution-shift ' +
      'benchmarks.',
    links: {
      arxiv: 'https://arxiv.org/abs/2605.15961',
      code: 'https://github.com/Fabian-Mor/sae-ft',
      // pdf: 'https://arxiv.org/pdf/2605.15961',
    },
    selected: true,
  },
];

export default publications;
